import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PizzaLasanhaGrid } from "src/app/pages/integracao/grid-pizzas-lasanhas/pizza-lasanha-grid.viewmodel";
import { ValoresPorSabor } from "src/app/shared/components/integracao-pizza-lasanha/integracao-pizza-lasanha.viewmodel";
import { ProdutosIntegracaoResponse, Tamanho } from "src/app/shared/models/produto.model";

@Injectable({
    providedIn: 'root'
})
export class PizzaLasanhaService {
    public pizzaGrid = new BehaviorSubject<PizzaLasanhaGrid[]>(null);
    public lasanhaGrid = new BehaviorSubject<PizzaLasanhaGrid[]>(null);
    public tamanhosPizza = new BehaviorSubject<Tamanho[]>(null);
    public tamanhosLasanha = new BehaviorSubject<Tamanho[]>(null);

    public alterarStatus(codigoProduto: number, ativo: boolean) {
        const pizzas = this.pizzaGrid.value; // BehaviorSubject<PizzaLasanhaGrid[]>

        const novasPizzas = pizzas.map((pizza) => {
            let codigoEncontrado = false;

            const novosTamanhos = pizza.tamanhos.map((tamanho) => {
                if (tamanho.codigoProduto === codigoProduto) {
                    codigoEncontrado = true;
                    // apenas altera o campo 'ativo', mantendo o resto igual
                    return { ...tamanho, ativo } as ValoresPorSabor;
                }
                return tamanho; // já é um ValoresPorSabor
            });

            return {
                ...pizza,
                tamanhos: novosTamanhos,
                ativo: codigoEncontrado ? ativo : pizza.ativo,
            } as PizzaLasanhaGrid;
        });

        this.pizzaGrid.next(novasPizzas);
    }

}